import React from 'react';
import { SpinLoading } from 'antd-mobile';

const Loader: React.FC = () => (
  <div
    style={{
      display: 'flex',
      height: '100vh',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <SpinLoading style={{ '--size': '48px' } as React.CSSProperties} />
  </div>
);

export default Loader;
